// src/pages/payments/pesapal.service.ts

const PESAPAL_STATUS_API_URL = 'https://us-central1-grema-62003.cloudfunctions.net/pesapal_status';

export const pesapalService = {
  /**
   * Calls the deployed Firebase Cloud Function (pesapal_status) 
   * to query PesaPal and save the status to Firestore.
   * @param orderTrackingId The order tracking ID from PesaPal redirect URL.
   * @returns The payment document data saved by the backend function.
   */
  getOrderStatus: async (orderTrackingId: string) => {
    try {
      const response = await fetch(PESAPAL_STATUS_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_tracking_id: orderTrackingId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown server error' }));
        throw new Error(`Failed to verify payment status: ${errorData.error}`);
      }

      const data = await response.json();
      return data.payment;
    } catch (error) {
      console.error('Error in getOrderStatus call:', error);
      throw error;
    }
  },
};